import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from "axios"
import vuetify from './plugins/vuetify'
import VueSmoothScroll from 'vue2-smooth-scroll'
import VueMeta from 'vue-meta'
import VueGtag from 'vue-gtag';

Vue.use(VueSmoothScroll)
Vue.use(VueMeta)

    // id: process.env.VUE_APP_GTAG_ID_CLICK 

Vue.use(VueGtag, {
    config: { id: process.env.VUE_APP_GTAG_ID},
    // GA4 ID
    params: {
        send_page_view: false // 자동 추적 끄기
    }
}, router);

router.afterEach((to) => {
    if (Vue.prototype.$gtag) {
        const query = to.query;

        Vue.prototype.$gtag.pageview({
            page_path: to.fullPath,
            page_location: window.location.href,
            page_title: document.title,
            send_to: process.env.VUE_APP_GTAG_ID,
            lang: query.lang || 'unknown',
            campaign: {
                source: query.utm_source || '(direct)',
                medium: query.utm_medium || '(none)',
                campaign: query.utm_campaign || undefined,
                term: query.utm_term || undefined,
                content: query.utm_content || undefined
            }
        })
    }
});

Vue.config.productionTip = false

const apiAuth = axios.create({
    baseURL: process.env.VUE_APP_API_AUTH
});

const apiWebsite = axios.create({
    baseURL: process.env.VUE_APP_API_WebStie
});


Vue.prototype.$apiAuth = apiAuth
Vue.prototype.$apiWebsite = apiWebsite
Vue.prototype.$axios = axios

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
